import apiClient from './apiClient';

class SMSService {
  // Send SMS to campaign target with optional recipient override
  async sendCampaignTargetSMS(targetId, overrideRecipient = null) {
    try {
      const requestBody = overrideRecipient ? { overrideRecipient } : {};
      
      const response = await apiClient.post(`/sms/campaign-target/${targetId}`, requestBody);
      return {
        success: true,
        data: response.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('SMS send error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to send SMS',
        error: error.response?.data?.error
      };
    }
  }

  // Send bulk SMS to multiple campaign targets
  async sendBulkCampaignSMS(campaignId, targetIds = [], options = {}) {
    try {
      const requestBody = {
        campaignId,
        targetIds,
        ...options
      };

      const response = await apiClient.post('/sms/campaign-bulk', requestBody);
      return {
        success: true,
        data: response.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Bulk SMS send error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to send bulk SMS',
        error: error.response?.data?.error
      };
    }
  }

  // Get SMS service status
  async getStatus() {
    try {
      const response = await apiClient.get('/sms/status');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('SMS status error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to get SMS status',
        error: error.response?.data?.error
      };
    }
  }

  // Search users for recipient selection
  async searchUsers(query) {
    try {
      if (!query || query.length < 2) {
        return {
          success: true,
          data: []
        };
      }

      const params = new URLSearchParams();
      params.append('q', query);

      const response = await apiClient.get(`/sms/search-users?${params.toString()}`);
      return {
        success: true,
        data: response.data?.users || response.data || []
      };
    } catch (error) {
      console.error('Search users error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to search users',
        data: []
      };
    }
  }

  // Upload a CSV of name/surname/phone/department/businessUnit rows and match
  // them against existing users by phone number (preview only, no writes)
  async matchCsvPeople(formData) {
    try {
      const response = await apiClient.post('/sms/match-csv-people', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return {
        success: true,
        data: response.data?.data || []
      };
    } catch (error) {
      console.error('Match CSV people error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to process CSV file',
        data: []
      };
    }
  }

  // Resolve reviewed CSV rows into actual users (reuse existing or create new)
  async resolveCsvPeople(rows) {
    try {
      const response = await apiClient.post('/sms/resolve-csv-people', { rows });
      return {
        success: true,
        data: response.data?.data || { resolved: [], failed: [] }
      };
    } catch (error) {
      console.error('Resolve CSV people error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to resolve CSV people',
        data: { resolved: [], failed: [] }
      };
    }
  }
}

// Create and export a singleton instance
const smsService = new SMSService();
export default smsService;